export default __webpack_public_path__ + "static/media/s3_male.8590ee9f.wav";